// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tests_content__SsRRt {
  margin-top: 70px;
  padding: 0 120px;
}

.tests_header_button__HxCeO {
  display: none;
}

.tests_orange_button__au-38 {
  width: 210px;
}

.tests_tests_block__ldcSh {
  background: #CCFFD1;
  border: 2px solid #7EDB88;
  border-radius: 25px;
  margin-bottom: 20px;
  padding: 12px 12px 20px 12px;
}
.tests_tests_block_inside__Vksg6 {
  border-radius: 20px 20px 12px 12px;
  padding: 25px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tests_tests_block_inside_pink__wPU6O {
  background: linear-gradient(to bottom, #DA6380, #EB86B5);
}
.tests_tests_block_inside_green__OxHPE {
  background: linear-gradient(to bottom, #299634, #4ECD5C);
  border: 2px solid #7EDB88;
}
.tests_tests_block_bottom__ZLj7z {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 0 20px;
}
.tests_tests_block_bottom_stats__6G58W {
  cursor: pointer;
  color: #636363;
  background: #FFFFFF;
  border-radius: 100px;
  padding: 8px 16px;
  font-family: var(--font-rubik);
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
}
.tests_tests_block_bottom_text__cz1Z8 {
  color: #636363;
  margin-left: 30px;
  font-family: var(--font-rubik);
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
}

.tests_after1024__Gx75z {
  display: none;
}

.tests_round__O3nEr {
  background: linear-gradient(to bottom, #EEFFBE 0%, #A4FBAD 40%, #A1F89A 80%, #BFFFB9 100%);
  border-radius: 50%;
  width: 116px;
  height: 116px;
  padding: 10px;
  margin-right: 28px;
}
.tests_round__O3nEr img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tests_header_block__B4bak img {
  width: auto;
}

@media screen and (max-width: 1300px) {
  .tests_content__SsRRt {
    padding: 0;
  }
  .tests_flexcenter__CMp9c {
    justify-content: center;
    align-items: center;
  }
  .tests_header_button__HxCeO {
    display: block;
  }
}
@media screen and (max-width: 1024px) {
  .tests_tests_block_inside__Vksg6 > div {
    align-items: center;
  }
  .tests_before1024__jv-sp {
    display: none;
  }
  .tests_after1024__Gx75z {
    display: block;
  }
  .tests_round__O3nEr {
    margin-right: 16px;
  }
  .tests_tests_block_inside__Vksg6 {
    padding: 24px;
  }
}
@media screen and (max-width: 768px) {
  .tests_after1024__Gx75z {
    display: none;
  }
  .tests_before1024__jv-sp {
    display: block;
  }
  .tests_tests_block_inside__Vksg6 {
    flex-direction: column;
  }
  .tests_tests_block_inside__Vksg6 > div {
    margin-bottom: 16px;
    flex-direction: column;
  }
  .tests_round__O3nEr {
    margin-right: 0;
    margin-bottom: 16px;
  }
  .tests_after1024__Gx75z {
    width: 116px;
    height: 75px;
  }
  .tests_edebiyati__20imO {
    width: 203px;
    height: 76px;
  }
}
@media screen and (max-width: 600px) {
  .tests_before1024__jv-sp {
    width: 100%;
  }
  .tests_flexcenter__CMp9c {
    padding: 8px 22px;
  }
  .tests_flexcenter__CMp9c img:nth-child(1) {
    width: 40px;
    height: 40px;
    margin-right: 12px !important;
  }
  .tests_flexcenter__CMp9c img:nth-child(2) {
    width: 233px;
    height: 20px;
  }
  .tests_tests_block_bottom__ZLj7z {
    flex-direction: column;
    align-items: center;
  }
  .tests_tests_block_bottom__ZLj7z > div {
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
  }
  .tests_tests_block_bottom_text__cz1Z8 {
    margin-left: 0;
    margin-bottom: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/tamyr/tests/tests.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;AACF;AAAE;EACE,kCAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAEJ;AAAE;EACE,wDAAA;AAEJ;AAAE;EACE,wDAAA;EACA,yBAAA;AAEJ;AAAE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAEJ;AADI;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAGN;AADI;EACE,cAAA;EACA,iBAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAGN;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,0FAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAEJ;;AAGE;EACE,WAAA;AAAJ;;AAKA;EAEE;IACE,UAAA;EAHF;EAMA;IACE,uBAAA;IACA,mBAAA;EAJF;EAOA;IACE,cAAA;EALF;AACF;AAQA;EAEE;IACE,mBAAA;EAPF;EAUA;IACE,aAAA;EARF;EAWA;IACE,cAAA;EATF;EAYA;IACE,kBAAA;EAVF;EAaA;IACE,aAAA;EAXF;AACF;AAcA;EAEE;IACE,aAAA;EAbF;EAgBA;IACE,cAAA;EAdF;EAiBA;IACE,sBAAA;EAfF;EAgBE;IACE,mBAAA;IACA,sBAAA;EAdJ;EAkBA;IACE,eAAA;IACA,mBAAA;EAhBF;EAmBA;IACE,YAAA;IACA,YAAA;EAjBF;EAoBA;IACE,YAAA;IACA,YAAA;EAlBF;AACF;AAqBA;EAEE;IACE,WAAA;EApBF;EAuBA;IACE,iBAAA;EArBF;EAsBE;IACE,WAAA;IACA,YAAA;IACA,6BAAA;EApBJ;EAsBE;IACE,YAAA;IACA,YAAA;EApBJ;EAwBA;IACE,sBAAA;IACA,mBAAA;EAtBF;EAuBE;IACE,sBAAA;IACA,mBAAA;IACA,mBAAA;EArBJ;EAyBA;IACE,cAAA;IACA,kBAAA;EAvBF;AACF","sourcesContent":[".content {\n  margin-top: 70px;\n  padding: 0 120px;\n}\n\n.header_button {\n  display: none;\n}\n\n.orange_button {\n  width: 210px;\n}\n\n.tests_block {\n  background: #CCFFD1;\n  border: 2px solid #7EDB88;\n  border-radius: 25px;\n  margin-bottom: 20px;\n  padding: 12px 12px 20px 12px;\n  &_inside {\n    border-radius: 20px 20px 12px 12px;\n    padding: 25px 30px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  &_inside_pink {\n    background: linear-gradient(to bottom, #DA6380, #EB86B5);\n  }\n  &_inside_green {\n    background: linear-gradient(to bottom, #299634, #4ECD5C);\n    border: 2px solid #7EDB88;\n  }\n  &_bottom {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 20px;\n    padding: 0 20px;\n    &_stats {\n      cursor: pointer;\n      color: #636363;\n      background: #FFFFFF;\n      border-radius: 100px;\n      padding: 8px 16px;\n      font-family: var(--font-rubik);\n      font-weight: 500;\n      font-size: 18px;\n      line-height: 22px;\n    }\n    &_text {\n      color: #636363;\n      margin-left: 30px;\n      font-family: var(--font-rubik);\n      font-weight: 500;\n      font-size: 18px;\n      line-height: 22px;\n    }\n  }\n}\n\n.after1024 {\n  display: none;\n}\n\n.round {\n  background: linear-gradient(to bottom, #EEFFBE 0%, #A4FBAD 40%, #A1F89A 80%, #BFFFB9 100%);\n  border-radius: 50%;\n  width: 116px;\n  height: 116px;\n  padding: 10px;\n  margin-right: 28px;\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.header_block {\n  img {\n    width: auto;\n  }\n}\n\n\n@media screen and (max-width: 1300px) {\n\n  .content {\n    padding: 0;\n  }\n\n  .flexcenter {\n    justify-content: center;\n    align-items: center;\n  }\n\n  .header_button {\n    display: block;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n\n  .tests_block_inside > div {\n    align-items: center;\n  }\n\n  .before1024 {\n    display: none;\n  }\n\n  .after1024 {\n    display: block;\n  }\n\n  .round {\n    margin-right: 16px;\n  }\n\n  .tests_block_inside {\n    padding: 24px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n\n  .after1024 {\n    display: none;\n  }\n\n  .before1024 {\n    display: block;\n  }\n\n  .tests_block_inside {\n    flex-direction: column;\n    & > div {\n      margin-bottom: 16px;\n      flex-direction: column;\n    }\n  }\n\n  .round {\n    margin-right: 0;\n    margin-bottom: 16px;\n  }\n\n  .after1024 {\n    width: 116px;\n    height: 75px;\n  }\n\n  .edebiyati {\n    width: 203px;\n    height: 76px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n\n  .before1024 {\n    width: 100%;\n  }\n\n  .flexcenter {\n    padding: 8px 22px;\n    img:nth-child(1) {\n      width: 40px;\n      height: 40px;\n      margin-right: 12px !important;\n    }\n    img:nth-child(2) {\n      width: 233px;\n      height: 20px;\n    }\n  }\n\n  .tests_block_bottom {\n    flex-direction: column;\n    align-items: center;\n    & > div {\n      flex-direction: column;\n      align-items: center;\n      margin-bottom: 20px;\n    }\n  }\n\n  .tests_block_bottom_text {\n    margin-left: 0;\n    margin-bottom: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `tests_content__SsRRt`,
	"header_button": `tests_header_button__HxCeO`,
	"orange_button": `tests_orange_button__au-38`,
	"tests_block": `tests_tests_block__ldcSh`,
	"tests_block_inside": `tests_tests_block_inside__Vksg6`,
	"tests_block_inside_pink": `tests_tests_block_inside_pink__wPU6O`,
	"tests_block_inside_green": `tests_tests_block_inside_green__OxHPE`,
	"tests_block_bottom": `tests_tests_block_bottom__ZLj7z`,
	"tests_block_bottom_stats": `tests_tests_block_bottom_stats__6G58W`,
	"tests_block_bottom_text": `tests_tests_block_bottom_text__cz1Z8`,
	"after1024": `tests_after1024__Gx75z`,
	"round": `tests_round__O3nEr`,
	"header_block": `tests_header_block__B4bak`,
	"flexcenter": `tests_flexcenter__CMp9c`,
	"before1024": `tests_before1024__jv-sp`,
	"edebiyati": `tests_edebiyati__20imO`
};
export default ___CSS_LOADER_EXPORT___;
